"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescriptionAuthority = exports.DetectionStatus = exports.STIMedicationProductCodeKey = exports.OTCMedicationProductCodeKey = exports.RxMedicationProductCodeKey = exports.STIMedicationProductUK = exports.RxMedicationProductUK = exports.OTCMedicationProductUS = exports.RxMedicationProductUS = exports.HTLabRejectionReason = exports.DTLabRejectionReason = exports.Pharmacy = exports.DeliveryServiceProvider = exports.Laboratory = exports.TreatmentStatus = exports.DTResultParameterType = exports.MicrobiomeBalance = exports.DTResultEvaluationDetection = exports.MedicalBrand = exports.MedicalResultButtonType = exports.ScreeningIcons = exports.MedicalDeviceVariation = exports.BodyMassIndex = exports.Ethnicity = exports.Sex = exports.AgeGroup = exports.HormoneReferenceRangeType = exports.HormoneCategory = exports.CyclePhase = exports.CalculatedValueRepresentation = exports.HormoneBiomarker = exports.ResultType = exports.ResultStatus = exports.CurrencySymbolForCode = exports.CurrencyCodeForSymbol = exports.CurrencyCode = exports.SubscriptionChangeTimeframe = exports.SubscriptionPlanCode = exports.SubscriptionType = exports.IntervalUnit = exports.CountryFlagForCode = exports.CountryName = exports.CountryCode = exports.ProductCodeKey = exports.ProductCode = exports.PaymentType = exports.SubscriptionService = exports.PurchaseItemType = exports.OrderStatusNames = exports.OrderStatus = void 0;
exports.Articles = exports.Resources = exports.Symptoms = exports.BiomarkerContributionCategory = exports.BiomarkerHelpType = exports.ScreeningType = exports.DiagnosticTamponType = exports.HormonalStepType = exports.ScreeningStepType = exports.ShippingProvider = exports.ResourceEffectiveness = exports.PackingProvider = exports.OrderType = exports.OrderPackingDepletionReason = exports.Consent = void 0;
var images_1 = require("../constants/images");
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Fulfilled"] = "fulfilled";
    OrderStatus["ReadyToMake"] = "ready_to_make";
    OrderStatus["Packing"] = "packing";
    OrderStatus["FailedToCreateInPms"] = "failed_to_create_in_pms";
    OrderStatus["FailedToCreateIn3PL"] = "failed_to_create_in_3pl";
    OrderStatus["FailedToUpdateInPms"] = "failed_to_update_in_pms";
    OrderStatus["WrongPostCode"] = "wrong_post_code";
    OrderStatus["Cancelled"] = "cancelled";
    OrderStatus["Pending"] = "pending";
    OrderStatus["PaymentPending"] = "payment_pending";
    OrderStatus["VMSAwaitingReturn"] = "vms_awaiting_return";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var OrderStatusNames;
(function (OrderStatusNames) {
    OrderStatusNames["fulfilled"] = "Fulfilled";
    OrderStatusNames["ready_to_make"] = "Ready to make";
    OrderStatusNames["packing"] = "Packing";
    OrderStatusNames["failed_to_create_in_pms"] = "Failed to create in PMS";
    OrderStatusNames["failed_to_create_in_3pl"] = "Failed to create in 3PL";
    OrderStatusNames["failed_to_update_in_pms"] = "Failed to update in PMS";
    OrderStatusNames["wrong_post_code"] = "Wrong post code";
    OrderStatusNames["cancelled"] = "Cancelled";
    OrderStatusNames["pending"] = "Pending";
    OrderStatusNames["paymentPending"] = "Payment pending";
    OrderStatusNames["vms_awaiting_return"] = "Vaginal Microbiome Screen awaiting return";
    OrderStatusNames["payment_pending"] = "Payment pending";
})(OrderStatusNames || (exports.OrderStatusNames = OrderStatusNames = {}));
var PurchaseItemType;
(function (PurchaseItemType) {
    PurchaseItemType["OneOffPurchase"] = "one_off_purchase";
    PurchaseItemType["SingleMonthSubscription"] = "subscription";
    PurchaseItemType["MultiMonthSubscription"] = "multi_month_subscription";
    PurchaseItemType["SubscriptionWithCredits"] = "subscription_with_credits";
    PurchaseItemType["OneOffPurchaseWithCredits"] = "one_off_purchase_with_credits";
    PurchaseItemType["B2B"] = "b2b";
    PurchaseItemType["Retail"] = "retail";
    PurchaseItemType["Consultation"] = "consultation";
})(PurchaseItemType || (exports.PurchaseItemType = PurchaseItemType = {}));
var SubscriptionService;
(function (SubscriptionService) {
    SubscriptionService["Recurly"] = "recurly";
    SubscriptionService["PayPal"] = "paypal";
    SubscriptionService["Flex"] = "flex";
})(SubscriptionService || (exports.SubscriptionService = SubscriptionService = {}));
/**
 * Enum representing the types of payment methods available.
 * Used to denote in an OrderCreateRequest which payment type is being used.
 */
var PaymentType;
(function (PaymentType) {
    PaymentType["Card"] = "card";
    PaymentType["PayPal"] = "paypal";
    PaymentType["ApplePay"] = "applepay";
    PaymentType["GooglePay"] = "googlepay";
    PaymentType["Flex"] = "flex";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var ProductCode;
(function (ProductCode) {
    ProductCode["tampon_box"] = "Tampon Box";
    ProductCode["pads_box"] = "Pads Box";
    ProductCode["proviotics"] = "ProViotics";
    ProductCode["mask_pink"] = "Mask (Gold Pink)";
    ProductCode["mask_blue"] = "Mask (Navy Sage)";
    ProductCode["mask_light"] = "Mask (Cream Pink)";
    ProductCode["mask_dark"] = "Mask (Lilac Forest)";
    ProductCode["cbdsuper"] = "CBD Super";
    ProductCode["cbdregular"] = "CBD Regular";
    ProductCode["cbdsuper10"] = "CBD Super";
    ProductCode["cbdregular10"] = "CBD Regular";
    ProductCode["cbdsuper20"] = "CBD Super";
    ProductCode["cbdregular20"] = "CBD Regular";
    ProductCode["cbdsuper30"] = "CBD Super";
    ProductCode["cbdregular30"] = "CBD Regular";
    ProductCode["nakedsuper"] = "Nude Super";
    ProductCode["nakedregular"] = "Nude Regular";
    ProductCode["initiationbox"] = "Initation Box";
    ProductCode["initiationbox_case"] = "Initiaton Box (with case)";
    ProductCode["refillbox"] = "Refill Box (Multi-Month)";
    ProductCode["pr"] = "Regular Pads";
    ProductCode["pn"] = "Super Pads";
    ProductCode["pnp"] = "Super+ Pads";
    ProductCode["pl"] = "Bamboo Liners";
    // New pads
    ProductCode["pad_regular"] = "Regular Pads";
    ProductCode["pad_super"] = "Super Pads";
    ProductCode["pad_super_plus"] = "Super+ Pads";
    ProductCode["cbd_balm"] = "Body Balm";
    ProductCode["blm_pin"] = "BLM Pin";
    ProductCode["gaf_box"] = "Gift A Friend Box";
    ProductCode["squish_box"] = "Squish Box";
    ProductCode["sampler"] = "Sampler";
    ProductCode["holiday_sampler"] = "Holiday Sampler";
    ProductCode["vagina_matters_book"] = "Vagina Matters Book";
    ProductCode["gift_card"] = "Gift Card";
    ProductCode["us_waitlist_prepaid_12"] = "US Waitlist Prepaid Box (12)";
    ProductCode["us_waitlist_prepaid_18"] = "US Waitlist Prepaid Box (18)";
    ProductCode["tin_case"] = "Tampon Case";
    ProductCode["tampon_pouch"] = "Tampon Pouch";
    ProductCode["screening_kit"] = "Diagnostic Tampon Kit";
    ProductCode["vms_essential"] = "Diagnostic Tampon Kit";
    ProductCode["vms_essential_consultation_basic"] = "Diagnostic Tampon With Nurse Consultation";
    ProductCode["vms_advanced"] = "Advanced Vaginal Health Screening";
    ProductCode["vms_premium"] = "HPV + STI + Microbiome Screen";
    ProductCode["hpv_screening"] = "HPV Screen";
    ProductCode["hpv_advanced"] = "HPV + Microbiome Screen";
    ProductCode["sti_screening"] = "STI Screening";
    ProductCode["vms_advanced_sti_4"] = "Advanced Vaginal Health Screening";
    ProductCode["sti_4_screening"] = "STI Screening";
    ProductCode["vms_essential_replacement"] = "Diagnostic Tampon Kit Replacement";
    ProductCode["ht_base_day3"] = "Hormone Test";
    ProductCode["ht_base_day3_expanded"] = "Hormone Test + Anti-M\u00FCllerian Hormone (AMH) Test";
    ProductCode["vms_medication_fee"] = "Vaginal Microbiome Screen Medication Fee";
    ProductCode["vms_prescription_fee"] = "Vaginal Microbiome Screen Prescription Fee";
    ProductCode["sti_medication_fee"] = "Prescriber review fee";
    ProductCode["sti_prescription_fee"] = "Prescriber review fee";
    ProductCode["rose_candle"] = "Rose Candle";
    ProductCode["ppc_standard"] = "Period Pain Clinic - Standard";
    ProductCode["ppc_advanced"] = "Period Pain Clinic - Advanced";
    ProductCode["ppc_premium"] = "Period Pain Clinic - Premium";
    ProductCode["ppc_tampon_box"] = "Prescription CBD Tampons";
    ProductCode["zidoval_gel"] = "Zidoval gel 0.75% (Metronidazole) 40g";
    ProductCode["tampon_box_bundle_regular_flow_mm"] = "3 Month Regular Flow Bundle";
    ProductCode["tampon_box_bundle_regular_flow"] = "Regular Flow Bundle";
    ProductCode["tampon_box_bundle_heavy_flow_mm"] = "3 Month Heavy Flow Bundle";
    ProductCode["tampon_box_bundle_heavy_flow"] = "Heavy Flow Bundle";
    ProductCode["tampon_box_retail_bundle_regular_flow_mm"] = "3 Month Regular Flow Bundle";
    ProductCode["tampon_box_retail_bundle_regular_flow"] = "Regular Flow Bundle";
    ProductCode["tampon_box_retail_bundle_heavy_flow_mm"] = "3 Month Heavy Flow Bundle";
    ProductCode["tampon_box_retail_bundle_heavy_flow"] = "Heavy Flow Bundle";
    ProductCode["tampon_box_bundle_cbd"] = "CBD Bundle";
    ProductCode["tampon_box_bundle_all_in_one_mm"] = "3 Month Period Care Bundle";
    ProductCode["tampon_box_bundle_all_in_one"] = "Period Care Bundle";
    ProductCode["tampon_box_9nr9ns"] = "9 Nude Regular and 9 Nude Super Tampons";
    ProductCode["tampon_box_9cs9ns"] = "9 Coated Super and 9 Nude Super Tampons";
    ProductCode["tampon_box_9cr9nr"] = "9 Coated Regular and 9 Nude Regular Tampons";
    ProductCode["tampon_box_9cr9cs9nr9ns"] = "3 Month Trial Tampon Box";
    ProductCode["tampon_box_9cr9cs"] = "9 Coated Regular and 9 Coated Super Tampons";
    ProductCode["tampon_box_4cr5cs5nr4ns"] = "Organic Tampons Trial Box";
    ProductCode["tampon_box_36ns"] = "36 Nude Super Tampons";
    ProductCode["tampon_box_36nr"] = "36 Nude Regular Tampons";
    ProductCode["tampon_box_36cs"] = "36 Coated Super Tampons";
    ProductCode["tampon_box_36cr"] = "36 Coated Regular Tampons";
    ProductCode["tampon_box_18ns"] = "18 Nude Super Tampons";
    ProductCode["tampon_box_18nr18ns"] = "18 Nude Regular and 18 Nude Super Tampons";
    ProductCode["tampon_box_18nr"] = "18 Nude Regular Tampons";
    ProductCode["tampon_box_18cs18ns"] = "18 Coated Super and 18 Nude Super Tampons";
    ProductCode["tampon_box_18cs"] = "18 Coated Super Tampons";
    ProductCode["tampon_box_18cr18nr"] = "18 Coated Regular and 18 Nude Regular Tampons";
    ProductCode["tampon_box_18cr18cs"] = "18 Coated Regular and 18 Coated Super Tampons";
    ProductCode["tampon_box_18cr"] = "18 Coated Regular Tampons";
    ProductCode["relactagel"] = "Relactagel 2%";
    ProductCode["proviotics_vaginal_health"] = "Vaginal Health Bundle";
    ProductCode["proviotics_mm"] = "ProViotic - 90 tablets";
    ProductCode["pads_box_8r8s3sp12l"] = "Bamboo Pads & Liners Trial Box";
    ProductCode["pads_box_48l"] = "48 Liners";
    ProductCode["pads_box_40s"] = "40 Super Pads";
    ProductCode["pads_box_40r"] = "40 Regular Pads";
    ProductCode["pads_box_32sp"] = "32 Super Plus Pads";
    ProductCode["pads_box_24l"] = "24 Liners";
    ProductCode["pads_box_12l"] = "12 Liners";
    ProductCode["pads_box_20s"] = "20 Super Pads";
    ProductCode["pads_box_20r20s"] = "20 Regular and 20 Super Pads";
    ProductCode["pads_box_20r"] = "20 Regular Pads";
    ProductCode["pads_box_16sp"] = "16 Super Plus Pads";
    ProductCode["pads_box_16r16s6sp24l"] = "3 Month Bamboo Pads & Liners Trial Box";
    ProductCode["pads_box_10r10s"] = "10 Regular and 10 Super Pads";
    ProductCode["pads_box_12_regular"] = "12 Regular Pads";
    ProductCode["pads_box_12_super"] = "12 Super Pads";
    ProductCode["pads_box_10_super_plus"] = "10 Super Plus Pads";
    ProductCode["fluconazole_150mg"] = "Fluconazole 150mg";
    ProductCode["flagyl_500mg"] = "Flagyl\u00AE 500mg (Metronidazole) tablets";
    ProductCode["clotrimazole_cream_50g"] = "Clotrimazole Cream 1% 50g";
    ProductCode["clotrimazole_cream_29g"] = "Clotrimazole Cream 1% 29g";
    ProductCode["clotrimazole_cream_21g"] = "Clotrimazole Cream 2% 21g";
    ProductCode["clotrimazole_cream_20g"] = "Clotrimazole Cream 1% 20g";
    ProductCode["clotrimazole_cream_15g"] = "Clotrimazole Cream 1% 15g";
    ProductCode["clotrimazole_500mg"] = "Clotrimazole 500mg";
    ProductCode["cleocin_40g"] = "Cleocin\u00AE 2% (Clindamycin) 40g";
    ProductCode["consultation_sexual_health"] = "Nurse consultation - 30-minute consultation with a sexual health nurse";
    ProductCode["consultation_fertility"] = "Fertility consultation - 30-minute consultation with a fertility specialist";
    ProductCode["consultation_nutritionist"] = "Nutritionist consultation - 45-minute consultation with a nutritional therapist";
    ProductCode["consultation_general_practitioner"] = "GP consultation - 15-minute consultation with a GP";
    ProductCode["consultation_pelvic_floor_therapist"] = "Pelvic floor therapist consultation - 45-minute consultation with a pelvic floor specialist";
    ProductCode["valentines_sampler"] = "Valentine's Sampler with scrunchie";
    ProductCode["valentines_box"] = "Valentine's Box";
    // items that were present in oms-frontend ProductVariant but missing in ProductCodeKey
    ProductCode["stitest"] = "STI Testing Kit";
    ProductCode["mask"] = "Mask";
    ProductCode["pib"] = "ProViotics Initiation Box";
    ProductCode["sub"] = "Substitute Box";
    ProductCode["scrunchie"] = "Scrunchie";
    ProductCode["gaf"] = "GAF Sample Box";
    ProductCode["ndtmo1"] = "NDT Month 1";
    ProductCode["ndtmo2"] = "NDT Month 2";
    ProductCode["ndtmo3"] = "NDT Month 3";
    ProductCode["ndtmo4"] = "NDT Month 4";
    ProductCode["mask_ndt"] = "Mask (NDT)";
    ProductCode["festive_bundle"] = "Festive Bundle";
    ProductCode["custom_order"] = "Custom Order";
})(ProductCode || (exports.ProductCode = ProductCode = {}));
var ProductCodeKey;
(function (ProductCodeKey) {
    ProductCodeKey["TamponBox"] = "tampon_box";
    ProductCodeKey["Pads"] = "pads_box";
    ProductCodeKey["Proviotics"] = "proviotics";
    ProductCodeKey["CbdBalm"] = "cbd_balm";
    ProductCodeKey["Sampler"] = "sampler";
    ProductCodeKey["HolidaySampler"] = "holiday_sampler";
    ProductCodeKey["SquishBox"] = "squish_box";
    ProductCodeKey["MaskPink"] = "mask_pink";
    ProductCodeKey["MaskBlue"] = "mask_blue";
    ProductCodeKey["MaskLight"] = "mask_light";
    ProductCodeKey["MaskDark"] = "mask_dark";
    ProductCodeKey["VaginaMattersBook"] = "vagina_matters_book";
    ProductCodeKey["GiftCard"] = "gift_card";
    ProductCodeKey["BlmPin"] = "blm_pin";
    ProductCodeKey["USWaitlistPrepaid12"] = "us_waitlist_prepaid_12";
    ProductCodeKey["USWaitlistPrepaid18"] = "us_waitlist_prepaid_18";
    ProductCodeKey["ValentinesSampler"] = "valentines_sampler";
    ProductCodeKey["ValentinesBox"] = "valentines_box";
    ProductCodeKey["TamponPouch"] = "tampon_pouch";
    ProductCodeKey["TamponTin"] = "tin_case";
    ProductCodeKey["ScreeningKit"] = "screening_kit";
    ProductCodeKey["VMSEssential"] = "vms_essential";
    ProductCodeKey["VMSAdvanced"] = "vms_advanced";
    ProductCodeKey["HPVScreening"] = "hpv_screening";
    ProductCodeKey["HPVAdvanced"] = "hpv_advanced";
    ProductCodeKey["VMSPremium"] = "vms_premium";
    ProductCodeKey["STIScreening"] = "sti_screening";
    ProductCodeKey["VMSAdvanced4STI"] = "vms_advanced_sti_4";
    ProductCodeKey["STI4Screening"] = "sti_4_screening";
    ProductCodeKey["VMSEssentialReplacement"] = "vms_essential_replacement";
    ProductCodeKey["VMSMedicationFee"] = "vms_medication_fee";
    ProductCodeKey["VMSPrescriptionFee"] = "vms_prescription_fee";
    ProductCodeKey["STIMedicationFee"] = "sti_medication_fee";
    ProductCodeKey["STIPrescriptionFee"] = "sti_prescription_fee";
    ProductCodeKey["VMSEssentialWithBasicConsultation"] = "vms_essential_consultation_basic";
    ProductCodeKey["HormonalTestBase"] = "ht_base_day3";
    ProductCodeKey["HormonalTestBaseAndAMH"] = "ht_base_day3_expanded";
    ProductCodeKey["VaginalHealthBundle"] = "proviotics_vaginal_health";
    ProductCodeKey["PPCTamponBox"] = "ppc_tampon_box";
    ProductCodeKey["PPCStandard"] = "ppc_standard";
    ProductCodeKey["PPCAdvanced"] = "ppc_advanced";
    ProductCodeKey["PPCPremium"] = "ppc_premium";
    ProductCodeKey["RoseCandle"] = "rose_candle";
    ProductCodeKey["FestiveBundle"] = "festive_bundle";
    // new hemp pads in a box
    ProductCodeKey["PadsRegular12"] = "pads_box_12_regular";
    ProductCodeKey["PadsSuper12"] = "pads_box_12_super";
    ProductCodeKey["PadsSuperPlus10"] = "pads_box_10_super_plus";
    ProductCodeKey["PadsLiners24"] = "pads_box_24l";
    // old bamboo pads single configuration
    ProductCodeKey["RegularPad"] = "pr";
    ProductCodeKey["SuperPad"] = "pn";
    ProductCodeKey["SuperPadPlus"] = "pnp";
    ProductCodeKey["LinerPad"] = "pl";
    // tampons
    ProductCodeKey["CBDRegular"] = "cbdregular";
    ProductCodeKey["CBDSuper"] = "cbdsuper";
    ProductCodeKey["NakedRegular"] = "nakedregular";
    ProductCodeKey["NakedSuper"] = "nakedsuper";
    ProductCodeKey["TamponInitiationBox"] = "initiationbox";
    ProductCodeKey["TamponInitiationBoxCase"] = "initiationbox_case";
    ProductCodeKey["TamponBoxBundleRegularFlowMm"] = "tampon_box_bundle_regular_flow_mm";
    ProductCodeKey["TamponBoxBundleRegularFlow"] = "tampon_box_bundle_regular_flow";
    ProductCodeKey["TamponBoxBundleHeavyFlowMm"] = "tampon_box_bundle_heavy_flow_mm";
    ProductCodeKey["TamponBoxBundleHeavyFlow"] = "tampon_box_bundle_heavy_flow";
    // New retail bundles
    ProductCodeKey["TamponRetailBoxBundleHeavyFlow"] = "tampon_box_retail_bundle_heavy_flow";
    ProductCodeKey["TamponRetailBoxBundleRegularFlow"] = "tampon_box_retail_bundle_regular_flow";
    ProductCodeKey["TamponRetailBoxBundleHeavyFlowMm"] = "tampon_box_retail_bundle_heavy_flow_mm";
    ProductCodeKey["TamponRetailBoxBundleRegularFlowMm"] = "tampon_box_retail_bundle_regular_flow_mm";
    ProductCodeKey["CustomOrder"] = "custom_order";
    // replacement kits
    ProductCodeKey["HormonalTestBaseReplacement"] = "ht_base_day3_replacement";
    ProductCodeKey["HormonalTestBaseAndAMHReplacement"] = "ht_base_day3_expanded_replacement";
    ProductCodeKey["VMSAdvancedReplacement"] = "vms_advanced_replacement";
    ProductCodeKey["HPVScreeningReplacement"] = "hpv_screening_replacement";
    ProductCodeKey["VMSPremiumReplacement"] = "vms_premium_replacement";
    ProductCodeKey["VMSAdvanced4STIReplacement"] = "vms_advanced_sti_4_replacement";
    ProductCodeKey["STI4ScreeningReplacement"] = "sti_4_screening_replacement";
    ProductCodeKey["HPVAdvancedReplacement"] = "hpv_advanced_replacement";
})(ProductCodeKey || (exports.ProductCodeKey = ProductCodeKey = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["GB"] = "GB";
    CountryCode["DE"] = "DE";
    CountryCode["NL"] = "NL";
    CountryCode["IE"] = "IE";
    CountryCode["BE"] = "BE";
    CountryCode["IT"] = "IT";
    CountryCode["ES"] = "ES";
    CountryCode["PT"] = "PT";
    CountryCode["BG"] = "BG";
    CountryCode["FR"] = "FR";
    CountryCode["US"] = "US";
    CountryCode["SE"] = "SE";
    CountryCode["DK"] = "DK";
    CountryCode["NO"] = "NO";
    CountryCode["FI"] = "FI";
    CountryCode["AT"] = "AT";
    CountryCode["CH"] = "CH";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
var CountryName;
(function (CountryName) {
    CountryName["GB"] = "United Kingdom";
    CountryName["NL"] = "Netherlands";
    CountryName["IE"] = "Ireland";
    CountryName["BE"] = "Belgium";
    CountryName["IT"] = "Italy";
    CountryName["ES"] = "Spain";
    CountryName["PT"] = "Portugal";
    CountryName["BG"] = "Bulgaria";
    CountryName["DE"] = "Germany";
    CountryName["FR"] = "France";
    CountryName["US"] = "United States";
    CountryName["SE"] = "Sweden";
    CountryName["DK"] = "Denmark";
    CountryName["NO"] = "Norway";
    CountryName["FI"] = "Finland";
    CountryName["AT"] = "Austria";
    CountryName["CH"] = "Switzerland";
})(CountryName || (exports.CountryName = CountryName = {}));
var CountryFlagForCode;
(function (CountryFlagForCode) {
    CountryFlagForCode["NL"] = "\uD83C\uDDF3\uD83C\uDDF1";
    CountryFlagForCode["GB"] = "\uD83C\uDDEC\uD83C\uDDE7";
    CountryFlagForCode["EN"] = "\uD83C\uDDEC\uD83C\uDDE7";
    CountryFlagForCode["IE"] = "\uD83C\uDDEE\uD83C\uDDEA";
    CountryFlagForCode["BE"] = "\uD83C\uDDE7\uD83C\uDDEA";
    CountryFlagForCode["IT"] = "\uD83C\uDDEE\uD83C\uDDF9";
    CountryFlagForCode["DE"] = "\uD83C\uDDE9\uD83C\uDDEA";
    CountryFlagForCode["ES"] = "\uD83C\uDDEA\uD83C\uDDF8";
    CountryFlagForCode["PT"] = "\uD83C\uDDF5\uD83C\uDDF9";
    CountryFlagForCode["BG"] = "\uD83C\uDDE7\uD83C\uDDEC";
    CountryFlagForCode["FR"] = "\uD83C\uDDEB\uD83C\uDDF7";
    CountryFlagForCode["US"] = "\uD83C\uDDFA\uD83C\uDDF8";
    CountryFlagForCode["SE"] = "\uD83C\uDDF8\uD83C\uDDEA";
    CountryFlagForCode["DK"] = "\uD83C\uDDE9\uD83C\uDDF0";
    CountryFlagForCode["NO"] = "\uD83C\uDDF3\uD83C\uDDF4";
    CountryFlagForCode["FI"] = "\uD83C\uDDEB\uD83C\uDDEE";
    CountryFlagForCode["AT"] = "\uD83C\uDDE6\uD83C\uDDF9";
    CountryFlagForCode["CH"] = "\uD83C\uDDE8\uD83C\uDDED";
})(CountryFlagForCode || (exports.CountryFlagForCode = CountryFlagForCode = {}));
var IntervalUnit;
(function (IntervalUnit) {
    IntervalUnit["Days"] = "days";
    IntervalUnit["Months"] = "months";
})(IntervalUnit || (exports.IntervalUnit = IntervalUnit = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Tampons"] = "tampons";
    SubscriptionType["Proviotics"] = "proviotics";
    SubscriptionType["VMS"] = "vms";
    SubscriptionType["Pads"] = "pads";
})(SubscriptionType || (exports.SubscriptionType = SubscriptionType = {}));
var SubscriptionPlanCode;
(function (SubscriptionPlanCode) {
    SubscriptionPlanCode["Tampons1Month"] = "tampon_1_month";
    SubscriptionPlanCode["Tampons3Month"] = "tampon_3_month";
    SubscriptionPlanCode["Tampons6Month"] = "tampon_6_month";
    SubscriptionPlanCode["Tampons6MonthUpfront"] = "tampon_6_month_upfront";
    SubscriptionPlanCode["Tampons12Month"] = "tampon_12_month";
    SubscriptionPlanCode["Tampons12MonthUpfront"] = "tampon_12_month_upfront";
    SubscriptionPlanCode["Proviotics1Month"] = "proviotics_1_month";
    SubscriptionPlanCode["Proviotics3Month"] = "proviotics_3_month";
    SubscriptionPlanCode["Proviotics6Month"] = "proviotics_6_month";
    SubscriptionPlanCode["Proviotics6MonthUpfront"] = "proviotics_6_month_upfront";
    SubscriptionPlanCode["Proviotics12Month"] = "proviotics_12_month";
    SubscriptionPlanCode["Proviotics12MonthUpfront"] = "proviotics_12_month_upfront";
    SubscriptionPlanCode["ScreeningKit"] = "screening_kit";
    SubscriptionPlanCode["B2B"] = "b2b";
    SubscriptionPlanCode["B2B6Weeks"] = "b2b_6week";
    SubscriptionPlanCode["Retail2Weeks"] = "retail_14";
    SubscriptionPlanCode["Retail4Weeks"] = "retail_28";
    SubscriptionPlanCode["Retail2Months"] = "retail_60";
    SubscriptionPlanCode["Retail3Months"] = "retail_90";
    SubscriptionPlanCode["Pads1Month"] = "pads_1_month";
    SubscriptionPlanCode["Pads3Month"] = "pads_3_month";
    SubscriptionPlanCode["Pads6Month"] = "pads_6_month";
    SubscriptionPlanCode["Pads12Month"] = "pads_12_month";
    SubscriptionPlanCode["PPCTamponBox3Month"] = "ppc_tampon_3_month";
    SubscriptionPlanCode["Company1MonthBasic"] = "company_1_month_basic";
    SubscriptionPlanCode["Company1MonthStandard"] = "company_1_month_standard";
    SubscriptionPlanCode["Company1MonthPlus"] = "company_1_month_plus";
    SubscriptionPlanCode["Company3MonthBasic"] = "company_3_month_basic";
    SubscriptionPlanCode["Company3MonthStandard"] = "company_3_month_standard";
    SubscriptionPlanCode["Company3MonthPlus"] = "company_3_month_plus";
    SubscriptionPlanCode["Company6MonthBasic"] = "company_6_month_basic";
    SubscriptionPlanCode["Company6MonthStandard"] = "company_6_month_standard";
    SubscriptionPlanCode["Company6MonthPlus"] = "company_6_month_plus";
    SubscriptionPlanCode["Company12MonthBasic"] = "company_12_month_basic";
    SubscriptionPlanCode["Company12MonthStandard"] = "company_12_month_standard";
    SubscriptionPlanCode["Company12MonthPlus"] = "company_12_month_plus";
})(SubscriptionPlanCode || (exports.SubscriptionPlanCode = SubscriptionPlanCode = {}));
var SubscriptionChangeTimeframe;
(function (SubscriptionChangeTimeframe) {
    SubscriptionChangeTimeframe["Renewal"] = "renewal";
    SubscriptionChangeTimeframe["BillDate"] = "bill_date";
    SubscriptionChangeTimeframe["Now"] = "now";
})(SubscriptionChangeTimeframe || (exports.SubscriptionChangeTimeframe = SubscriptionChangeTimeframe = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["USD"] = "USD";
    CurrencyCode["BGN"] = "BGN";
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));
var CurrencyCodeForSymbol;
(function (CurrencyCodeForSymbol) {
    CurrencyCodeForSymbol["\u00A3"] = "GBP";
    CurrencyCodeForSymbol["\u20AC"] = "EUR";
    CurrencyCodeForSymbol["$"] = "USD";
    CurrencyCodeForSymbol["\u043B\u0432"] = "BGN";
})(CurrencyCodeForSymbol || (exports.CurrencyCodeForSymbol = CurrencyCodeForSymbol = {}));
var CurrencySymbolForCode;
(function (CurrencySymbolForCode) {
    CurrencySymbolForCode["GBP"] = "\u00A3";
    CurrencySymbolForCode["EUR"] = "\u20AC";
    CurrencySymbolForCode["USD"] = "$";
    CurrencySymbolForCode["BGN"] = "\u043B\u0432";
})(CurrencySymbolForCode || (exports.CurrencySymbolForCode = CurrencySymbolForCode = {}));
var ResultStatus;
(function (ResultStatus) {
    ResultStatus["Pending"] = "pending";
    ResultStatus["Rejected"] = "rejected";
    ResultStatus["AwaitingSampleCollection"] = "awaiting_sample_collection";
    ResultStatus["AwaitingReturn"] = "awaiting_return";
    ResultStatus["AwaitingSample"] = "awaiting_sample";
    ResultStatus["SampleInTransit"] = "sample_in_transit";
    ResultStatus["ReviewPending"] = "review_pending";
    ResultStatus["SampleReceived"] = "sample_received";
    ResultStatus["SampleProcessing"] = "sample_processing";
    ResultStatus["SamplePendingRelease"] = "sample_pending_release";
    ResultStatus["ResultsReturned"] = "results_returned";
    ResultStatus["Expired"] = "expired";
})(ResultStatus || (exports.ResultStatus = ResultStatus = {}));
var ResultType;
(function (ResultType) {
    // Basic types:
    ResultType["VMSEssential"] = "vms_essential";
    ResultType["STIScreening"] = "sti_screening";
    ResultType["HPVScreening"] = "hpv_screening";
    // Advanced Types:
    ResultType["VMSAdvanced"] = "vms_advanced";
    ResultType["HPVAdvanced"] = "hpv_advanced";
    // Premium Types:
    ResultType["VMSPremium"] = "vms_premium";
    // Lab variations:
    ResultType["VMSAdvanced4STI"] = "vms_advanced_sti_4";
    ResultType["STI4Screening"] = "sti_4_screening";
    ResultType["HPVNHS"] = "hpv_nhs";
    // Hormonal Tests
    /**
     * Day 3 Hormonal Test. Includes the following hormones:
     * - Follicle stimulating hormone
     * - Luteinizing hormone
     * - Oestradiol
     * - Total Testosterone
     * - Free Androgen Index
     * - Prolactin
     * - Sex Hormone Binding globulin
     * - Thyroid Stimulating Hormone
     * - Free T4
     * - Ferritin
     */
    ResultType["HTBase"] = "ht_base_day3";
    /**
     * Day 3 Hormonal Test + AMH
     */
    ResultType["HTBaseAndAMH"] = "ht_base_day3_expanded";
})(ResultType || (exports.ResultType = ResultType = {}));
var HormoneBiomarker;
(function (HormoneBiomarker) {
    HormoneBiomarker["FollicleStimulatingHormone"] = "follicle_stimulating_hormone";
    HormoneBiomarker["LuteinizingHormone"] = "luteinizing_hormone";
    HormoneBiomarker["Oestradiol"] = "oestradiol";
    HormoneBiomarker["TotalTestosterone"] = "total_testosterone";
    HormoneBiomarker["FreeAndrogenIndex"] = "free_androgen_index";
    HormoneBiomarker["Prolactin"] = "prolactin";
    HormoneBiomarker["SexHormoneBindingGlobulin"] = "sex_hormone_binding_globulin";
    HormoneBiomarker["ThyroidStimulatingHormone"] = "thyroid_stimulating_hormone";
    HormoneBiomarker["Ferritin"] = "ferritin";
    HormoneBiomarker["AntiMullerianHormone"] = "anti_mullerian_hormone";
    HormoneBiomarker["VitaminD"] = "vitamin_d";
    HormoneBiomarker["FreeT4"] = "free_t4";
})(HormoneBiomarker || (exports.HormoneBiomarker = HormoneBiomarker = {}));
var CalculatedValueRepresentation;
(function (CalculatedValueRepresentation) {
    CalculatedValueRepresentation["Low"] = "low";
    CalculatedValueRepresentation["InRange"] = "in_range";
    CalculatedValueRepresentation["Insufficient"] = "insufficient";
    CalculatedValueRepresentation["Optimal"] = "optimal";
    CalculatedValueRepresentation["High"] = "high";
})(CalculatedValueRepresentation || (exports.CalculatedValueRepresentation = CalculatedValueRepresentation = {}));
var CyclePhase;
(function (CyclePhase) {
    CyclePhase["Follicular"] = "Follicular";
    CyclePhase["MidCycle"] = "MidCycle";
    CyclePhase["Luteal"] = "Luteal";
    CyclePhase["Menopause"] = "Menopause";
})(CyclePhase || (exports.CyclePhase = CyclePhase = {}));
var HormoneCategory;
(function (HormoneCategory) {
    HormoneCategory["PituitaryHormones"] = "pituitary_hormones";
    HormoneCategory["OvarianSexHormones"] = "ovarian_sex_hormones";
    HormoneCategory["ThyroidHormones"] = "thyroid_hormones";
    HormoneCategory["Other"] = "other";
})(HormoneCategory || (exports.HormoneCategory = HormoneCategory = {}));
var HormoneReferenceRangeType;
(function (HormoneReferenceRangeType) {
    HormoneReferenceRangeType["MenstrualCycle"] = "menstrual_cycle";
    HormoneReferenceRangeType["AgeGroup"] = "age_group";
    HormoneReferenceRangeType["Sex"] = "sex";
    HormoneReferenceRangeType["Ethnicity"] = "ethnicity";
    HormoneReferenceRangeType["BodyMassIndex"] = "body_mass_index";
})(HormoneReferenceRangeType || (exports.HormoneReferenceRangeType = HormoneReferenceRangeType = {}));
var AgeGroup;
(function (AgeGroup) {
    AgeGroup["15-19"] = "15-19";
    AgeGroup["20-29"] = "20-29";
    AgeGroup["30-34"] = "30-34";
    AgeGroup["35-39"] = "35-39";
    AgeGroup["40-44"] = "40-44";
    AgeGroup["45-50"] = "45-50";
    AgeGroup["50+"] = "50+";
})(AgeGroup || (exports.AgeGroup = AgeGroup = {}));
var Sex;
(function (Sex) {
    Sex["Male"] = "male";
    Sex["Female"] = "female";
})(Sex || (exports.Sex = Sex = {}));
var Ethnicity;
(function (Ethnicity) {
    Ethnicity["White"] = "white";
    Ethnicity["MiddleEastern"] = "middle_eastern";
    Ethnicity["BlackAfricanCaribbeanBlackBritish"] = "black_african_caribbean_black_british";
    Ethnicity["AsianAsianBritish"] = "asian_asian_british";
    Ethnicity["HispanicOrLatino"] = "hispanic_or_latino";
    Ethnicity["MixedMultipleEthnicGroups"] = "mixed_multiple_ethnic_groups";
    Ethnicity["Other"] = "other";
})(Ethnicity || (exports.Ethnicity = Ethnicity = {}));
var BodyMassIndex;
(function (BodyMassIndex) {
    BodyMassIndex["Underweight"] = "underweight";
    BodyMassIndex["Normal"] = "normal";
    BodyMassIndex["Overweight"] = "overweight";
    BodyMassIndex["Obese"] = "obese";
})(BodyMassIndex || (exports.BodyMassIndex = BodyMassIndex = {}));
var MedicalDeviceVariation;
(function (MedicalDeviceVariation) {
    MedicalDeviceVariation["GelPack"] = "gel_pack";
    MedicalDeviceVariation["TransportMedium"] = "transport_medium";
    MedicalDeviceVariation["NoMedium"] = "no_medium";
    MedicalDeviceVariation["RetailBox"] = "retail_box";
    MedicalDeviceVariation["RetailBoxWisp"] = "retail_box_wisp";
    MedicalDeviceVariation["D2CBoxWisp"] = "d2c_box_wisp";
    MedicalDeviceVariation["NewLifeFertilityClinic"] = "new_life_fertility_clinic";
    MedicalDeviceVariation["ClinicBoxNHS"] = "clinic_box_nhs";
    MedicalDeviceVariation["D2CBoxIreland"] = "d2c_box_ireland";
    MedicalDeviceVariation["D2CBoxGermany"] = "d2c_box_germany";
})(MedicalDeviceVariation || (exports.MedicalDeviceVariation = MedicalDeviceVariation = {}));
var ScreeningIcons;
(function (ScreeningIcons) {
    ScreeningIcons["All"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRlNMt2UUcvBPJO_MicrobiomeScreening.svg";
    ScreeningIcons["AllWithCircle"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRjP8t2UUcvBPIm_ScreeningsCircleIcon.svg";
    ScreeningIcons["STI"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRlNct2UUcvBPJP_STIs.svg";
    ScreeningIcons["STIMono"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRntMt2UUcvBPKV_StiMono.svg";
    ScreeningIcons["STIWithCircle"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRjPct2UUcvBPIk_STICircleIcon.svg";
    ScreeningIcons["VMS"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRlNst2UUcvBPJQ_VMS.svg";
    ScreeningIcons["VMSMono"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRns8t2UUcvBPKU_MicrobiomeMono.svg";
    ScreeningIcons["VMSWithCircle"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRjPst2UUcvBPIl_VMSCircleIcon.svg";
    ScreeningIcons["HPV"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRlN8t2UUcvBPJR_HPV.svg";
    ScreeningIcons["HPVMono"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRns8t2UUcvBPKU_MicrobiomeMono.svg";
    ScreeningIcons["HPVWithCircle"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZgRjPMt2UUcvBPIj_HPVCircleIcon.svg";
    ScreeningIcons["Hormonal"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/aAeHjVvg_A-GMufy_HormonalTesting.svg";
    ScreeningIcons["HormonalWithCircle"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/aAeHjVvg_A-GMufy_HormonalTesting.svg";
    ScreeningIcons["MycoplasmaGenitalium"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZfbdFsmUzjad_Tq7_vms-flora-mycoplasmas.svg";
    ScreeningIcons["Trichomoniasis"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/8b38c157-3d0b-4c1d-bb9a-2f0f85ad1bbd_sti-trichomoniasis-icon.svg";
    ScreeningIcons["Gonorrhoea"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/88db3621-5e85-41c2-96bd-3950f9e9786a_sti-gonorrhea-icon.svg";
    ScreeningIcons["Chlamydia"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/b3723fe2-5c66-4591-ae8c-3a6d56481ba6_sti-clamydia-icon.svg";
    ScreeningIcons["Ureaplasma"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZiE3aPPdc1huKnNn_ureaplasma_icon.svg";
    ScreeningIcons["MycoplasmaHominis"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZiE3MPPdc1huKnNh_mycoplasma-h_icon.svg";
    ScreeningIcons["AnaerobicMicroorganisms"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/9c56a09e-2ad0-42aa-8b65-e7078f46f528_vms-flora-bacteria.svg";
    ScreeningIcons["Candida"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ad19d0d7-0e2c-4804-99a1-d64aaadf1602_vms-flora-fungi.svg";
    ScreeningIcons["Lactobacillus"] = "https://ecommerce-website.cdn.prismic.io/ecommerce-website/ZfbdFcmUzjad_Tq6_vms-flora-lactobacilli.svg";
})(ScreeningIcons || (exports.ScreeningIcons = ScreeningIcons = {}));
var MedicalResultButtonType;
(function (MedicalResultButtonType) {
    MedicalResultButtonType["Info"] = "info";
    MedicalResultButtonType["Action"] = "action";
})(MedicalResultButtonType || (exports.MedicalResultButtonType = MedicalResultButtonType = {}));
var MedicalBrand;
(function (MedicalBrand) {
    MedicalBrand["Wisp"] = "retail_box_wisp";
    MedicalBrand["Boots"] = "retail_box_boots";
})(MedicalBrand || (exports.MedicalBrand = MedicalBrand = {}));
var DTResultEvaluationDetection;
(function (DTResultEvaluationDetection) {
    DTResultEvaluationDetection["Inconclusive"] = "inconclusive";
    DTResultEvaluationDetection["NotDetected"] = "not-detected";
    DTResultEvaluationDetection["InAbundance"] = "in-abundance";
    DTResultEvaluationDetection["Reduced"] = "reduced";
    DTResultEvaluationDetection["Depleted"] = "depleted";
    DTResultEvaluationDetection["Detected"] = "detected";
    DTResultEvaluationDetection["DetectedNormal"] = "detected-normal";
    DTResultEvaluationDetection["DetectedAbnormal"] = "detected-abnormal";
})(DTResultEvaluationDetection || (exports.DTResultEvaluationDetection = DTResultEvaluationDetection = {}));
var MicrobiomeBalance;
(function (MicrobiomeBalance) {
    MicrobiomeBalance["WellBalanced"] = "well-balanced";
    MicrobiomeBalance["ModeratelyDisbalancedAnaerobic"] = "moderately-disbalanced-anaerobic";
    MicrobiomeBalance["ModeratelyDisbalancedOther"] = "moderately-disbalanced-other";
    MicrobiomeBalance["DisbalancedAnaerobic"] = "disbalanced-anaerobic";
    MicrobiomeBalance["DisbalancedOther"] = "disbalanced-other";
    MicrobiomeBalance["Undetermined"] = "undetermined";
})(MicrobiomeBalance || (exports.MicrobiomeBalance = MicrobiomeBalance = {}));
var DTResultParameterType;
(function (DTResultParameterType) {
    DTResultParameterType["SAMPLE_INTAKE_CONTROL"] = "sampleIntakeControl";
    DTResultParameterType["TOTAL_BACTERIAL_MASS"] = "totalBacterialMass";
    DTResultParameterType["LACTOBACILLUS"] = "lactobacillus";
    DTResultParameterType["CANDIDA"] = "candida";
    DTResultParameterType["ANAEROBIC_MICROORGANISMS"] = "anaerobicMicroorganisms";
    DTResultParameterType["MYCOPLASMA_UREAPLASMA"] = "mycoplasmaUreaplasma";
    DTResultParameterType["MYCOPLASMA_HOMINIS"] = "mycoplasmaHominis";
    DTResultParameterType["UREAPLASMA"] = "ureaplasma";
    DTResultParameterType["CHLAMYDIA"] = "chlamydia";
    DTResultParameterType["GONORRHOEA"] = "gonorrhoea";
    DTResultParameterType["TRICHOMONIASIS"] = "trichomoniasis";
    DTResultParameterType["MYCOPLASMA_GENITALIUM"] = "mycoplasmaGenitalium";
    DTResultParameterType["HPV16"] = "hpv16";
    DTResultParameterType["HPV18"] = "hpv18";
    DTResultParameterType["HPV_OTHER"] = "hpvOther";
})(DTResultParameterType || (exports.DTResultParameterType = DTResultParameterType = {}));
var TreatmentStatus;
(function (TreatmentStatus) {
    TreatmentStatus["Pending"] = "pending";
    TreatmentStatus["RequiresAction"] = "requires_action";
    TreatmentStatus["Rejected"] = "rejected";
    TreatmentStatus["Approved"] = "approved";
    TreatmentStatus["WithPharmacy"] = "with_pharmacy";
    TreatmentStatus["Dispatched"] = "dispatched";
})(TreatmentStatus || (exports.TreatmentStatus = TreatmentStatus = {}));
var Laboratory;
(function (Laboratory) {
    Laboratory["SalientBio"] = "salientbio";
    Laboratory["AlderleyLighthouseLabs"] = "alderleylighthouselabs";
    Laboratory["Avrok"] = "avrok";
})(Laboratory || (exports.Laboratory = Laboratory = {}));
var DeliveryServiceProvider;
(function (DeliveryServiceProvider) {
    DeliveryServiceProvider["RoyalMail"] = "RoyalMail";
    DeliveryServiceProvider["USPS"] = "USPS";
})(DeliveryServiceProvider || (exports.DeliveryServiceProvider = DeliveryServiceProvider = {}));
var Pharmacy;
(function (Pharmacy) {
    Pharmacy["Truepill"] = "truepill";
    Pharmacy["Cedarwood"] = "cedarwood";
    Pharmacy["Phlo"] = "phlo";
    Pharmacy["Curexa"] = "curexa";
    Pharmacy["Blueco"] = "blueco";
})(Pharmacy || (exports.Pharmacy = Pharmacy = {}));
var DTLabRejectionReason;
(function (DTLabRejectionReason) {
    DTLabRejectionReason["BloodOnTampon"] = "1: Blood on tampon";
    DTLabRejectionReason["LongTransitTime"] = "2: Long transit time to lab";
    DTLabRejectionReason["DamagedPackaging"] = "3: Damaged packaging";
    DTLabRejectionReason["NotDayeTampon"] = "4: Not Daye tampon";
    DTLabRejectionReason["ContaminatedTampon"] = "5: Contaminated tampon";
    DTLabRejectionReason["InconclusiveResult"] = "6: Inconclusive result";
    DTLabRejectionReason["InconclusiveResultNoErrorCode"] = "Inconclusive result";
})(DTLabRejectionReason || (exports.DTLabRejectionReason = DTLabRejectionReason = {}));
var HTLabRejectionReason;
(function (HTLabRejectionReason) {
    HTLabRejectionReason["SampleLeakedInTransit"] = "LEAK: Sample leaked in transit";
    HTLabRejectionReason["InsufficientSample"] = "INS: Insufficient sample";
    HTLabRejectionReason["HaemolysedSample"] = "HAEM: Haemolysed sample";
    HTLabRejectionReason["GrosslyHaemolysedSample"] = "GHAEM: Grossly haemolysed sample";
    HTLabRejectionReason["SampleTooOld"] = "OLD: Sample too old";
    HTLabRejectionReason["BarcodePatientDetailsMismatch"] = "MATCH: Barcode/patient details mismatch";
    HTLabRejectionReason["NoSampleReceived"] = "NSR: No sample received";
    HTLabRejectionReason["IncorrectTubeReceived"] = "TUBE: Incorrect tube received";
    HTLabRejectionReason["LabError"] = "LAB: Lab error";
    HTLabRejectionReason["IctericSample"] = "ICT: Icteric sample";
    HTLabRejectionReason["LipaemicSample"] = "LIP: Lipaemic sample";
    HTLabRejectionReason["ClottedViscousSample"] = "CLOT: Clotted/viscous sample";
    HTLabRejectionReason["EDTAContamination"] = "EDTA: EDTA contamination";
    HTLabRejectionReason["UnableToPerformCalculation"] = "UNC: Unable to perform calculation";
    HTLabRejectionReason["NoRequestEOrderReceived"] = "REQ: No request/e-order received";
})(HTLabRejectionReason || (exports.HTLabRejectionReason = HTLabRejectionReason = {}));
var RxMedicationProductUS;
(function (RxMedicationProductUS) {
    RxMedicationProductUS["fluconazole_150mg"] = "Fluconazole 150mg";
    RxMedicationProductUS["cleocin_40g"] = "Cleocin\u00AE 2% (Clindamycin) 40g";
    RxMedicationProductUS["flagyl_500mg"] = "Flagyl\u00AE (Metronidazole) 500mg";
    RxMedicationProductUS["zidoval_gel"] = "Zidoval gel 0.75% (Metronidazole) 40g";
})(RxMedicationProductUS || (exports.RxMedicationProductUS = RxMedicationProductUS = {}));
var OTCMedicationProductUS;
(function (OTCMedicationProductUS) {
    OTCMedicationProductUS["clotrimazole_cream_29g"] = "Clotrimazole Cream 1% 29g";
    OTCMedicationProductUS["clotrimazole_cream_15g"] = "Clotrimazole Cream 1% 15g";
    OTCMedicationProductUS["clotrimazole_cream_21g"] = "Clotrimazole Cream 2% 21g";
    OTCMedicationProductUS["boric_acid_capsules"] = "Boric acid capsules";
})(OTCMedicationProductUS || (exports.OTCMedicationProductUS = OTCMedicationProductUS = {}));
var RxMedicationProductUK;
(function (RxMedicationProductUK) {
    RxMedicationProductUK["clotrimazole_cream_20g"] = "Clotrimazole Cream 1% 20g";
    RxMedicationProductUK["clotrimazole_cream_50g"] = "Clotrimazole Cream 1% 50g";
    RxMedicationProductUK["clotrimazole_500mg"] = "Clotrimazole 500mg";
    RxMedicationProductUK["fluconazole_150mg"] = "Fluconazole 150mg";
    RxMedicationProductUK["relactagel"] = "Relactagel";
    RxMedicationProductUK["ppc_tampon_box"] = "Period Pain Clinic Tampon Box";
})(RxMedicationProductUK || (exports.RxMedicationProductUK = RxMedicationProductUK = {}));
var STIMedicationProductUK;
(function (STIMedicationProductUK) {
    STIMedicationProductUK["sti_help_me_decide_treatment"] = "Daye STI Treatment (help-me-decide)";
    // Chlamydia
    STIMedicationProductUK["doxycycline_100mg"] = "Doxycycline 100mg (14 doses)";
    STIMedicationProductUK["azithromycin_500mg"] = "Azithromycin 500mg (4 doses)";
    // Mycoplasma genitalium
    STIMedicationProductUK["combined_doxycycline_100mg_azithromycin_500mg"] = "Doxycycline 100mg (14 doses) + Azithromycin 500 mg (4 doses)";
    // Trichomoniasis
    STIMedicationProductUK["metronidazole_400mg"] = "Metronidazole 400mg (14 doses)";
})(STIMedicationProductUK || (exports.STIMedicationProductUK = STIMedicationProductUK = {}));
var RxMedicationProductCodeKey;
(function (RxMedicationProductCodeKey) {
    RxMedicationProductCodeKey["Fluconazole150mg"] = "fluconazole_150mg";
    RxMedicationProductCodeKey["Cleocin40g"] = "cleocin_40g";
    RxMedicationProductCodeKey["Flagyl500mg"] = "flagyl_500mg";
    RxMedicationProductCodeKey["ZidovalGel"] = "zidoval_gel";
    // UK PRODUCTS
    RxMedicationProductCodeKey["ClotrimazoleCream20g"] = "clotrimazole_cream_20g";
    RxMedicationProductCodeKey["ClotrimazoleCream50g"] = "clotrimazole_cream_50g";
    RxMedicationProductCodeKey["Clotrimazole500mg"] = "clotrimazole_500mg";
    RxMedicationProductCodeKey["Relactagel"] = "relactagel";
    RxMedicationProductCodeKey["PPCTamponBox"] = "ppc_tampon_box";
})(RxMedicationProductCodeKey || (exports.RxMedicationProductCodeKey = RxMedicationProductCodeKey = {}));
var OTCMedicationProductCodeKey;
(function (OTCMedicationProductCodeKey) {
    OTCMedicationProductCodeKey["ClotrimazoleCream29g"] = "clotrimazole_cream_29g";
    OTCMedicationProductCodeKey["ClotrimazoleCream15g"] = "clotrimazole_cream_15g";
    OTCMedicationProductCodeKey["ClotrimazoleCream21g"] = "clotrimazole_cream_21g";
    OTCMedicationProductCodeKey["BoricAcidCapsules"] = "boric_acid_capsules";
})(OTCMedicationProductCodeKey || (exports.OTCMedicationProductCodeKey = OTCMedicationProductCodeKey = {}));
var STIMedicationProductCodeKey;
(function (STIMedicationProductCodeKey) {
    STIMedicationProductCodeKey["STIHelpMeDecideTreatment"] = "sti_help_me_decide_treatment";
    STIMedicationProductCodeKey["Doxycycline100mg"] = "doxycycline_100mg";
    STIMedicationProductCodeKey["Azithromycin500mg"] = "azithromycin_500mg";
    STIMedicationProductCodeKey["Metronidazole400mg"] = "metronidazole_400mg";
    STIMedicationProductCodeKey["CombinedDoxycycline100mgAzithromycin500mg"] = "combined_doxycycline_100mg_azithromycin_500mg";
})(STIMedicationProductCodeKey || (exports.STIMedicationProductCodeKey = STIMedicationProductCodeKey = {}));
var DetectionStatus;
(function (DetectionStatus) {
    DetectionStatus["Detected"] = "detected";
    DetectionStatus["NotDetected"] = "not_detected";
    DetectionStatus["Inconclusive"] = "inconclusive";
})(DetectionStatus || (exports.DetectionStatus = DetectionStatus = {}));
var PrescriptionAuthority;
(function (PrescriptionAuthority) {
    PrescriptionAuthority["MDIntegrations"] = "mdi";
    PrescriptionAuthority["Cliniko"] = "cliniko";
})(PrescriptionAuthority || (exports.PrescriptionAuthority = PrescriptionAuthority = {}));
var Consent;
(function (Consent) {
    Consent["YES"] = "yes";
    Consent["NO"] = "no";
})(Consent || (exports.Consent = Consent = {}));
var OrderPackingDepletionReason;
(function (OrderPackingDepletionReason) {
    OrderPackingDepletionReason["Fulfilment"] = "Fulfilment";
    OrderPackingDepletionReason["Production"] = "Production";
    OrderPackingDepletionReason["Scrap"] = "Scrap";
    OrderPackingDepletionReason["Equalizing"] = "Equalizing";
    OrderPackingDepletionReason["ToInitial"] = "ToInitial";
    OrderPackingDepletionReason["StockMove"] = "StockMove";
    OrderPackingDepletionReason["ResearchAndDevelopment"] = "R&D";
    OrderPackingDepletionReason["Samples"] = "Samples";
    OrderPackingDepletionReason["Kitting"] = "Kitting";
})(OrderPackingDepletionReason || (exports.OrderPackingDepletionReason = OrderPackingDepletionReason = {}));
var OrderType;
(function (OrderType) {
    OrderType["D2C"] = "D2C";
    OrderType["B2B"] = "B2B";
    OrderType["Retailer"] = "Retailer";
    OrderType["RnD"] = "R&D";
    OrderType["CX_Marketing"] = "CX/Marketing";
    OrderType["Replacements_MissingItems"] = "Replacements/MissingItems";
})(OrderType || (exports.OrderType = OrderType = {}));
var PackingProvider;
(function (PackingProvider) {
    PackingProvider["Daye"] = "daye";
    PackingProvider["Fusion"] = "fusion";
    PackingProvider["XPDEL"] = "xpdel";
})(PackingProvider || (exports.PackingProvider = PackingProvider = {}));
/**
 * Represents the effectiveness of a resource based on customer feedback.
 * @enum {string}
 */
var ResourceEffectiveness;
(function (ResourceEffectiveness) {
    /** No feedback has been provided */
    ResourceEffectiveness["NotInterested"] = "Not interested";
    /** Customer showed interest in providing feedback but didn't select an option */
    ResourceEffectiveness["Interested"] = "Interested";
    /** Resource was found to be not effective */
    ResourceEffectiveness["NotEffective"] = "Not effective";
    /** Resource was found to be somewhat effective */
    ResourceEffectiveness["SomewhatEffective"] = "Somewhat effective";
    /** Resource was found to be very effective */
    ResourceEffectiveness["VeryEffective"] = "Very effective";
})(ResourceEffectiveness || (exports.ResourceEffectiveness = ResourceEffectiveness = {}));
var ShippingProvider;
(function (ShippingProvider) {
    ShippingProvider["RoyalMail"] = "royal-mail";
    ShippingProvider["Whistl"] = "whistl";
    ShippingProvider["PostOne"] = "post-one";
    ShippingProvider["DHL"] = "dhl";
    ShippingProvider["Default"] = "default";
})(ShippingProvider || (exports.ShippingProvider = ShippingProvider = {}));
var ScreeningStepType;
(function (ScreeningStepType) {
    ScreeningStepType["Specialists"] = "specialists";
    ScreeningStepType["SpecialistsWisp"] = "specialistsWisp";
    ScreeningStepType["TreatmentOptions"] = "treatmentOptions";
    ScreeningStepType["Retest"] = "retest";
    ScreeningStepType["RetestWisp"] = "retestWisp";
    ScreeningStepType["PreventInfections"] = "preventInfections";
    ScreeningStepType["PreventionWisp"] = "preventionWisp";
    ScreeningStepType["DownloadPDF"] = "downloadPDF";
})(ScreeningStepType || (exports.ScreeningStepType = ScreeningStepType = {}));
var HormonalStepType;
(function (HormonalStepType) {
    HormonalStepType["Specialists"] = "specialists";
    HormonalStepType["Resources"] = "resources";
})(HormonalStepType || (exports.HormonalStepType = HormonalStepType = {}));
var DiagnosticTamponType;
(function (DiagnosticTamponType) {
    DiagnosticTamponType["Vms"] = "vms";
    DiagnosticTamponType["Sti"] = "sti";
    DiagnosticTamponType["Hpv"] = "hpv";
})(DiagnosticTamponType || (exports.DiagnosticTamponType = DiagnosticTamponType = {}));
var ScreeningType;
(function (ScreeningType) {
    ScreeningType["DiagnosticTampon"] = "diagnostic-tampon";
    ScreeningType["HormonalTest"] = "hormonal-test";
})(ScreeningType || (exports.ScreeningType = ScreeningType = {}));
var BiomarkerHelpType;
(function (BiomarkerHelpType) {
    BiomarkerHelpType["Specialists"] = "specialists";
    BiomarkerHelpType["PeriodPain"] = "period-pain";
})(BiomarkerHelpType || (exports.BiomarkerHelpType = BiomarkerHelpType = {}));
var BiomarkerContributionCategory;
(function (BiomarkerContributionCategory) {
    BiomarkerContributionCategory["Age"] = "age";
    BiomarkerContributionCategory["Aging"] = "aging";
    BiomarkerContributionCategory["AgeRelatedChanges"] = "age-related-changes";
    BiomarkerContributionCategory["AdrenalInsufficiency"] = "adrenal-insufficiency";
    BiomarkerContributionCategory["AdrenalOrOvarianConditionsLessCommon"] = "adrenal-or-ovarian-conditions-less-common";
    BiomarkerContributionCategory["Alcohol"] = "alchohol";
    BiomarkerContributionCategory["Breastfeeding"] = "breastfeeding";
    BiomarkerContributionCategory["CalorieRestrictionOrSuddenWeightLoss"] = "calorie-restriction-or-sudden-weight-loss";
    BiomarkerContributionCategory["CertainMedicalTreatmentsOrConditions"] = "certain-medical-treatments-or-conditions";
    BiomarkerContributionCategory["CertainMedications"] = "certain-medications";
    BiomarkerContributionCategory["CertainEthnicities"] = "certain-ethnicities";
    BiomarkerContributionCategory["CongenitalAdrenalHyperplasia"] = "congenital-adrenal-hyperplasia";
    BiomarkerContributionCategory["ChemotherapyOrRadiation"] = "chemotherapy-or-radiation";
    BiomarkerContributionCategory["DarkerSkinTone"] = "darker-skin-tone";
    BiomarkerContributionCategory["DietaryFactors"] = "dietary-factors";
    BiomarkerContributionCategory["EatingDisordersOrBeingUnderweight"] = "eating-disorders-or-being-underweight";
    BiomarkerContributionCategory["EnvironmentalEstrogens"] = "environmental-estrogens";
    BiomarkerContributionCategory["EatingDisordersOrExtremeDieting"] = "eating-disorders-or-extreme-dieting";
    BiomarkerContributionCategory["ExcessAndrogens"] = "excess-androgens";
    BiomarkerContributionCategory["ExcessiveThyroidMedication"] = "excessive-thyroid-medication";
    BiomarkerContributionCategory["EstrogenEffects"] = "estrogen-effects";
    BiomarkerContributionCategory["GeneticFactors"] = "genetic-factors";
    BiomarkerContributionCategory["GravesDisease"] = "graves-disease";
    BiomarkerContributionCategory["HighEstrogenStates"] = "high-estrogen-states";
    BiomarkerContributionCategory["HormonalContraceptives"] = "hormonal-contraceptives";
    BiomarkerContributionCategory["HormonalContraceptivesHrt"] = "hormonal-contraceptives-hrt";
    BiomarkerContributionCategory["Hypothyroidism"] = "hypothyroidism";
    BiomarkerContributionCategory["Hyperthyroidism"] = "hyperthyroidism";
    BiomarkerContributionCategory["LiverDisease"] = "liver-disease";
    BiomarkerContributionCategory["LowBodyWeightOrRestrictiveEating"] = "low-body-weight-or-restrictive-eating";
    BiomarkerContributionCategory["Medications"] = "medications";
    BiomarkerContributionCategory["MedicationsHRT"] = "medications-hrt";
    BiomarkerContributionCategory["MedicalConditions"] = "medical-conditions";
    BiomarkerContributionCategory["NaturalAgingAndReproductiveTransitions"] = "natural-aging-and-reproductive-transitions";
    BiomarkerContributionCategory["NaturalCycleToCycleVariations"] = "natural-cycle-to-cycle-variations";
    BiomarkerContributionCategory["NaturalVariationsInYourCycle"] = "natural-variations-in-your-cycle";
    BiomarkerContributionCategory["NaturalVariationsInYourCycleReproductive"] = "natural-variations-in-your-cycle-reproductive";
    BiomarkerContributionCategory["NippleStimulation"] = "nipple-stimulation";
    BiomarkerContributionCategory["NodularGoiterOrThyroidConditions"] = "nodular-goiter-or-thyroid-conditions";
    BiomarkerContributionCategory["NormalMidCycleSurgeBeforeOvulation"] = "normal-mid-cycle-surge-before-ovulation";
    BiomarkerContributionCategory["Overexercising"] = "overexercising";
    BiomarkerContributionCategory["Obesity"] = "obesity";
    BiomarkerContributionCategory["OvarianConditionsRare"] = "ovarian-conditions-rare";
    BiomarkerContributionCategory["PerimenopauseAndMenopauseTransitions"] = "perimenopause-and-menopause-transitions";
    BiomarkerContributionCategory["PituitaryConditions"] = "pituitary-conditions";
    BiomarkerContributionCategory["PituitaryConditionsLessCommon"] = "pituitary-conditions-less-common";
    BiomarkerContributionCategory["PolycysticOvarySyndrome"] = "polycystic-ovary-syndrome";
    BiomarkerContributionCategory["Pregnancy"] = "pregnancy";
    BiomarkerContributionCategory["PregnancyFirstTrimester"] = "pregnancy-first-trimester";
    BiomarkerContributionCategory["PregnancyAndBreastfeeding"] = "pregnancy-and-breastfeeding";
    BiomarkerContributionCategory["PreviousOvarianSurgery"] = "previous-ovarian-surgery";
    BiomarkerContributionCategory["PrematureOvarianInsufficiency"] = "premature-ovarian-insufficiency";
    BiomarkerContributionCategory["PrematureOvarianInsufficiencyInYoungerWomen"] = "premature-ovarian-insufficiency-in-younger-women";
    BiomarkerContributionCategory["RecoveringFromIllness"] = "recovering-from-illness";
    BiomarkerContributionCategory["InsulinResistance"] = "insulin-resistance";
    BiomarkerContributionCategory["IodineDeficiency"] = "iodine-deficiency";
    BiomarkerContributionCategory["SeasonalChanges"] = "seasonal-changes";
    BiomarkerContributionCategory["SleepDisruptionOrRecentExcercise"] = "sleep-disruption-or-recent-excercise";
    BiomarkerContributionCategory["Stress"] = "stress";
    BiomarkerContributionCategory["StressPhysicalOrEmotional"] = "stress-physical-or-emotional";
    BiomarkerContributionCategory["SurgicalRemovalOfTheOvaries"] = "surgical-removal-of-the-ovaries";
    BiomarkerContributionCategory["HashimotoThyroiditis"] = "hashimoto-thyroiditis";
    BiomarkerContributionCategory["VariationsInOvarianFunction"] = "variations-in-ovarian-function";
    BiomarkerContributionCategory["Thyroiditis"] = "thyroiditis";
    BiomarkerContributionCategory["YoungerAge"] = "younger-age";
    BiomarkerContributionCategory["LimitedSunExposure"] = "limited-sun-exposure";
    BiomarkerContributionCategory["HealthConditions"] = "health-conditions";
    BiomarkerContributionCategory["DietaryFactorsPlant"] = "dietary-factors-plant";
    BiomarkerContributionCategory["DietaryFactorsFish"] = "dietary-factors-fish";
    BiomarkerContributionCategory["WeightGain"] = "weight-gain";
    BiomarkerContributionCategory["Menstruation"] = "menstruation";
    BiomarkerContributionCategory["PregnancyAndChildbirth"] = "pregnancy-and-childbirth";
    BiomarkerContributionCategory["AbsorptionIssues"] = "absorption-issues";
    BiomarkerContributionCategory["BloodLoss"] = "blood-loss";
    BiomarkerContributionCategory["HormonalInfluences"] = "hormonal-influences";
    BiomarkerContributionCategory["Inflammation"] = "inflammation";
    BiomarkerContributionCategory["GeneticConditions"] = "genetic-conditions";
    BiomarkerContributionCategory["ExcessiveSupplementation"] = "excessive-supplementation";
    BiomarkerContributionCategory["LiverConditions"] = "liver-conditions";
    BiomarkerContributionCategory["MetabolicConditions"] = "metabolic-conditions";
    BiomarkerContributionCategory["AlcoholConsumption"] = "alcohol-consumption";
})(BiomarkerContributionCategory || (exports.BiomarkerContributionCategory = BiomarkerContributionCategory = {}));
/**
 * Represents the symptoms that can be selected by the user, not all are added yet, just the needed ones for HT.
 * @enum {string}
 */
var Symptoms;
(function (Symptoms) {
    Symptoms["UnusualVaginalDischarge"] = "unusual-vaginal-discharge";
    Symptoms["IrregularPeriods"] = "irregular-periods";
    Symptoms["Menopause"] = "menopause";
    Symptoms["Perimenopause"] = "perimenopause";
    Symptoms["DelayedPubertyMenstruation"] = "delayed-puberty-menstruation";
    Symptoms["LightPeriods"] = "light-periods";
    Symptoms["HeavyPeriods"] = "heavy-periods";
    Symptoms["PeriodHeadaches"] = "period-headaches";
    Symptoms["VaginalDryness"] = "vaginal-dryness";
    Symptoms["ConsideringHRT"] = "considering-hrt";
    Symptoms["SuspectingPCOS"] = "suspecting-pcos";
    Symptoms["NoPeriodLastYear"] = "no-period-last-year";
    Symptoms["PrematureMenopause"] = "premature-menopause";
    Symptoms["PolycysticOvarySyndrome"] = "polycystic-ovary-syndrome";
    Symptoms["MenstrualCramps"] = "menstrual-cramps";
    Symptoms["RecurringThrushOrBV"] = "recurring-thrush-or-bv";
    Symptoms["SleepDisturbances"] = "sleep-disturbances";
    Symptoms["VaginalBurning"] = "vaginal-burning";
    Symptoms["DeepPenetrationPain"] = "deep-penetration-pain";
    Symptoms["VulvalDiscomfort"] = "vulval-discomfort";
    Symptoms["VaginalDiscomfort"] = "vaginal-discomfort";
    Symptoms["Acne"] = "acne";
    Symptoms["HairLoss"] = "hair-loss";
    Symptoms["FeelingCold"] = "feeling-cold";
    Symptoms["FeelingHot"] = "feeling-hot";
    Symptoms["HotFlashes"] = "hot-flashes";
    Symptoms["Moodiness"] = "moodiness";
    Symptoms["BreastTenderness"] = "breast-tenderness";
    Symptoms["IncreasedFacialOrBodyHair"] = "increased-facial-or-body-hair";
    Symptoms["Constipation"] = "constipation";
    Symptoms["WeightGain"] = "weight-gain";
    Symptoms["WeightLoss"] = "weight-loss";
    Symptoms["RapidHeartbeat"] = "rapid-heartbeat";
    Symptoms["Fatigue"] = "fatigue";
    Symptoms["CognitiveIssues"] = "cognitive-issues";
    Symptoms["NippleDischarge"] = "nipple-discharge";
    Symptoms["BrittleNails"] = "brittle-nails";
    Symptoms["DrySkinHair"] = "dry-skin-hair";
    Symptoms["MuscleWeakness"] = "muscle-weakness";
    Symptoms["BoneMusclePain"] = "bone-muscle-pain";
    Symptoms["IncreasedLibido"] = "increased-libido";
    Symptoms["DecreasedLibido"] = "decreased-libido";
    Symptoms["Headaches"] = "headaches";
    Symptoms["Anxiety"] = "anxiety";
    Symptoms["Depression"] = "depression";
    Symptoms["Fibroids"] = "fibroids";
    Symptoms["NoBreastMilkAfterBirth"] = "no-breast-milk-after-birth";
    Symptoms["DifficultyConceiving"] = "difficulty-conceiving";
    Symptoms["Diarrhea"] = "diarrhea";
    Symptoms["HighStress"] = "high-stress";
    Symptoms["VeryHighStress"] = "very-high-stress";
    Symptoms["Diabetes"] = "diabetes";
    Symptoms["PrematureOvarianInsufficiency"] = "premature-ovarian-insufficiency";
})(Symptoms || (exports.Symptoms = Symptoms = {}));
/**
 * Represents the prismic resources ids, not all are added yet, just the needed ones for HT.
 * @enum {string}
 */
var Resources;
(function (Resources) {
    Resources["HormonalAcneCareHT"] = "hormonal-acne-care-ht";
    Resources["GutHealth"] = "gut-health";
    Resources["CycleTracking"] = "cycle-tracking";
    Resources["PeriodPelvicPain"] = "period-pelvic-pain";
    Resources["StressManagement"] = "stress-management";
    Resources["BetterSleep"] = "better-sleep";
    Resources["Caffeine"] = "caffeine";
    Resources["HRT"] = "hrt";
    Resources["VitaminD"] = "vitamin-d";
    Resources["IronLevels"] = "iron-levels";
    Resources["InositolHT"] = "inositol-ht";
    Resources["VaginalHealthScreeningHT"] = "vaginal-health-screening-ht";
})(Resources || (exports.Resources = Resources = {}));
/**
 * Represents the prismic articles ids, not all are added yet, just the needed ones for HT.
 * @enum {string}
 */
var Articles;
(function (Articles) {
    Articles["WhatHappensToYourVaginaDuringMenopause"] = "what-happens-to-your-vagina-during-menopause";
    Articles["MenopauseAndTheVaginalMicrobiome"] = "menopause-and-the-vaginal-microbiome";
    Articles["HowCanIReduceMenopauseSymptoms"] = "how-can-i-reduce-menopause-symptoms";
    Articles["MenopauseLowLibido"] = "menopause-low-libido";
    Articles["YourCompleteFertilityPrepGuide"] = "your-complete-fertility-prep-guide";
    Articles["PCOSFactsMythsSymptomsTreatment"] = "pcos-facts-myths-symptoms-treatment";
    Articles["NoDenyingThatPCOSIsMore"] = "there-is-no-denying-that-pcos-is-more-than-just-a-lack";
    Articles["EarlyMenopauseSigns"] = "early-menopause-signs";
    Articles["EarlyMenopauseCondition"] = "earlymenopause-condition-menstrualhealth-menopause-womenshealth";
    Articles["PCOSWeightLoss"] = "pcos-weight-loss";
    Articles["PCOSHairLossAndHirsutism"] = "pcos-hair-loss-and-hirsutism";
    Articles["EndometriosisFertility"] = "endometriosis--fertility";
    Articles["ChronicStressHormonesMenstrualCycle"] = "-chronic-stress-hormones-menstrual-cycle";
    Articles["PMDDWomensHealthMentalHealth"] = "pmdd-womenshealth-mentalhealth-pms-symptoms-hormones-progesterone-estrogen";
    Articles["HeavyPeriodReasons"] = "heavy-period-reasons";
    Articles["OvarianTransplantsMenopauseTreatment"] = "ovarian-transplants-menopause-treatment";
    Articles["EndometriosisDiet"] = "endometriosis-diet";
    Articles["EndometriosisPain"] = "endometriosis-pain-menstrualhealth-womenshealth-chronic-condition1";
    Articles["HowPeriodsChangeAfterHavingABaby"] = "how-periods-change-after-having-a-baby";
})(Articles || (exports.Articles = Articles = {}));
